// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';
import {Href} from 'docs/markdoc/attribute-types';

export const BlockCard: MarkdocTagRegistration = {
  tag: 'card',
  component: 'BlockCard',
  attributes: {
    badge: {
      type: Object,
      required: false,
      localizable: ['text'],
      description: 'The badge to display next to the card title',
    },
    title: {
      type: String,
      required: true,
      localizable: true,
      description: 'The title of the card',
    },
    href: {
      type: Href,
      required: true,
      description: 'The URL that clicking the card will take you to',
    },
    product: {
      type: String,
      required: false,
      description: 'The product with which the card is associated',
    },
  },
};
